export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_xl1.f2e81238.jpg";